<template>
  <div class="mobile">
    <div :style="this.$store.state.note"></div>
    <div class="mobile-flex">
      <div class="mobile-left">
        <div class="mobile-left-L">
          <div
            v-for="(item,index) in other"
            :key="index"
            :class="[isActive==index?'active_class':'' ]"
            @click="classinfo(index)"
          >{{item.title}}</div>
        </div>
        <div class="mobile-left-R">
          <div class="wrapper" ref="wrapper">
            <div v-show="this.$store.state.flage" :style="{height:scrollTop+'rem'}">
              <div class="ncativ">
                <div
                  :class="classNum==0?'imageUrl':'image'"
                  v-for="(item,id) in this.$store.state.calligarr"
                  :key="id"
                >
                  <div :class="number==id?'active':'activeflage'" @click="callInfo(item,id)"></div>
                  <img :src="item.url" @click="callInfo(item,id)" alt />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mobile-right">
        <img class="mobile-right-img" src="../static/image/lamp.png" alt />
        <div class="mobile-right-content">
          <div :style="'height:' + this.height + 'px'">
            <img class="mobile-right-image" :src="this.$store.state.classUrl" alt />
          </div>
          
        </div>
        
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from "better-scroll";
export default {
  name: "mobile",
  data() {
    return {
      // 类别信息
      other: [
        {
          type: "windowtype",
          title: "窗型"
        },
        {
          type: "colour",
          title: "色彩"
        },
        {
          type: "scenery",
          title: "背景"
        }
      ],
      isActive: -1,
      classNum: 0,
      number: -1,
      start: 0,
      end: 0,
      scrollTop: 0
    };
  },
  created() {
    this.$message({
      message: "已进入移动端模式 建议横屏浏览",
      type: "success"
    });

    this.$store.state.calligarr=[];
    this.$store.state.classUrl='';
    
    console.log(this.$store.state.calligarr+'-'+this.$store.state.classUrl+'-'+this.scrollTop)

    this.height = document.documentElement.clientHeight || document.body.clientHeight;
  },
  mounted() {
    const options = { click: true, tap: true };
    this.$nextTick(() => {
      this.scroll = new BScroll(this.$refs.wrapper, options);
    });
  },
  methods: {
    classinfo(item) {
      console.log(item);
      this.number = -1;
      this.isActive = item;
      if (item == 0) {
        this.classNum = 0;
        this.scrollTop = 14;
      } else if (item == 1) {
        this.classNum = 1;
        this.scrollTop = 6;
      } else if (item == 2) {
        this.classNum = 0;
        this.scrollTop = 4;
      }

      this.$store.commit("classType", item);
      console.log(this.$store.state.calligarr);
      this.$store.state.calligarr.forEach(item => {
        item.url = require("../static/image/" + item.url);
      });
    },
    callInfo(item, id) {
      this.number = id;
      this.$store.dispatch("classTab", item);
    }
  }
};
</script>

<style>
* {
  font-size: 0.26rem;
}

.mobile {
  width: 100%;
  height: 100%;
}

.mobile div {
  width: 100%;
  height: 100%;
}

.mobile-flex {
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  display: -webkit-flex;
  display: flex;
}

.mobile-left {
  display: -webkit-flex;
  display: flex;
  background: #000;
  opacity: 0.8;
  flex: 1.3;
}

.mobile-right {
  flex: 3;
  position: relative;
}
.wrapper {
  width: 100%;
  height: 0.2rem;
  overflow: hidden;
  position: relative;
}
.mobile-right .mobile-right-img{
  width: 12%;
  height: 24.8%;
  position: absolute;
  left: 0;
  z-index: 1;
}
.mobile-left-L {
  flex: 0.8;
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
  color: #fff;
  text-align: center;
}

.mobile-left-L div {
  width: 0.4rem;
  font-size: 0.24rem;
  border: 0.01rem solid #ddd;
  flex: 1;
  padding: 0.2rem 0;
  border-radius: 0 0.1rem 0.1rem 0;
}

.mobile-left-L .active_class {
  width: 0.5rem;
  font-size: 0.26rem;
  border: 0.01rem solid #ddd;
  flex: 1;
  padding: 0.2rem 0;
  border-radius: 0 0.1rem 0.1rem 0;
  background: #333;
}

.mobile-left-R {
  flex: 3;
  padding: 0.2rem 0;
}

.mobile-left-R .ncativ {
  display: -webkit-flex;
  display: flex;
  flex-direction: column;
}

.ncativ_top{
  position: fixed;
  top: 50px;
}

.mobile-left-R .ncativ .imageUrl {
  width: 1.4rem;
  height: auto;
  margin: 0.1rem auto;
  position: relative;
}

.mobile-left-R .ncativ .active {
  width: 0.3rem;
  height: 0.3rem;
  position: absolute;
  left: 38%;
  top: 30%;
  background: url("../static/image/xuanze.png") no-repeat;
  background-size: 100% 100%;
  opacity: 0.9;
}
.mobile-left-R .ncativ .activeflage {
  width: 0.4rem;
  height: 0.4rem;
  position: absolute;
  left: 34%;
  top: 40%;
}

.mobile-left-R .ncativ .imageUrl img {
  width: 100%;
  height: 100%;
}

.mobile-left-R .ncativ .image {
  width: 0.9rem;
  height: auto;
  margin: 0.1rem auto;
  position: relative;
}

.mobile-left-R .ncativ .image img {
  width: 100%;
  height: 100%;
}
.el-message{
  min-width: 0.4rem !important;
}

.mobile .mobile-right-content {
  width: 800px;
  height: auto;
  position: absolute;
  left: 15%;
  right: 15%;
  text-align: center;
}

.mobile .mobile-right .mobile-right-content div{
  width: 100%;
  text-align: center;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  padding: 30px 0;
  margin: 0 auto;
}
.mobile .mobile-right .mobile-right-content div img {
  max-width: 100%;
}
</style>